import React from 'react';

const HowPublishersMakeMoney = () => (
  <>
    <p>
      The old publishing model — display ads next to editorial, priced against
      generic CPMs — is running out of road. It still pays the bills at most
      B2B houses, but the growth is elsewhere: in revenue lines that use the
      audience you already have to solve the buyer's problem, not just to
      surround it.
    </p>

    <h2>The seven revenue lines</h2>
    <p>Every publisher we work with is somewhere on this map:</p>
    <ol>
      <li>Traditional display + newsletter sponsorships</li>
      <li>Sponsored content and native studios</li>
      <li>Events and community</li>
      <li>Membership and paid subscriptions</li>
      <li>Data and audience products</li>
      <li>Performance media (lead generation, whitepaper syndication)</li>
      <li>Advisory and audience extension services</li>
    </ol>
    <p>
      Lines one through four are what most publishers already do. Lines five
      through seven are where 2026 growth is being booked, because they trade
      commodity attention for outcomes an advertiser can put a number on.
    </p>

    <h2>Why lead generation is the fastest onramp</h2>
    <p>
      Of the three growth lines, performance media is the fastest to stand
      up. You already have the audience, the trust and the editorial voice.
      What you don't have is the operating layer to verify, enrich and route
      leads at a speed advertisers accept. That is the whole game.
    </p>
    <p>
      When you get it right, the economics look different from display. A
      single campaign can contribute six figures with double-digit margin,
      and it compounds — the advertiser who ran a pilot last quarter is the
      one signing an annual programme this quarter.
    </p>

    <h2>What the winners do differently</h2>
    <ul>
      <li>
        <strong>Treat leads like a product, not a byproduct.</strong> Named
        SLA on delivery time and quality, published to the advertiser.
      </li>
      <li>
        <strong>Verify at ingest, not at handover.</strong> Waiting until
        the campaign ends to check quality is how you lose the renewal.
      </li>
      <li>
        <strong>Wrap the media buy in intelligence.</strong> A briefing on
        the target account is worth more to the advertiser than an extra
        thousand impressions.
      </li>
      <li>
        <strong>Own the margin conversation.</strong> The winners price on
        outcome, not on cost-plus.
      </li>
    </ul>

    <h2>The 90-day arc</h2>
    <p>
      In our experience with the publishers we work with, ninety days is
      enough to move from "we do a bit of lead gen" to "this is a named
      revenue line with its own P&amp;L." The bottleneck is almost never
      audience — it is operating discipline. If you would like a copy of the
      playbook we use for that ninety days, it's{' '}
      <a href="/#playbook" style={{ color: '#1e88e5', fontWeight: 700 }}>
        available here
      </a>
      .
    </p>
  </>
);

export default HowPublishersMakeMoney;
